import React, { Fragment } from 'react'
import { Grid, Divider } from '@material-ui/core'
import { Text, UpdateText, GridTextContainer, ProductsList } from './styles'
import { formatDate } from '../../../../common/helpers'
import PAID_LEAVE from '../../../constants'
import MarkdownRenderer from '../../../../common/components/markdown'
import jurisdictionTypes from '../../../../constants/jurisdictionTypes'
import { StyledDialogTitle, StyledDialogContent } from '../../../../theme/Global'

const PaidLeaveNotificationContentModal = ({ notification }) => {
  const jdDisplayName = [jurisdictionTypes.COUNTY, jurisdictionTypes.CITY].includes(notification.jurisdictionType)
    ? `${notification.jurisdictionName}, ${notification.jurisdictionStateCode}`
    : notification.jurisdictionName

  return (
    <Fragment>
      <StyledDialogTitle data-testid="pl-notification-title">
        {jdDisplayName}
      </StyledDialogTitle>
      <StyledDialogContent>
        <Grid container spacing={24}>
          <GridTextContainer align="flex-start" item xs={4}>
            <Text data-testid="pl-notification-date-of-change">
              <span>Date Of Change:</span>
              {formatDate(notification.dateOfChange)}
            </Text>
          </GridTextContainer>
          <GridTextContainer align="center" item xs={4}>
            <Text data-testid="pl-notification-type">
              <span>Type:</span>
              <ProductsList>
                {notification.paidLeaveType
                  ? notification.paidLeaveType.map((product) => (
                    <li key={product}>{PAID_LEAVE.PRODUCTS.find((paidLeaveType) => paidLeaveType.id === product).name}
                    </li>
                  ))
                  : null}
              </ProductsList>
            </Text>
          </GridTextContainer>
          <GridTextContainer align="flex-end" item xs={4}>
            <Text data-testid="pl-notification-jurisdictionName">
              <span>Jurisdiction:</span>
              {notification.jurisdictionName}
            </Text>
          </GridTextContainer>
          <Grid item xs={12}>
            <Divider />
            <UpdateText data-testid="pl-notification-update">
              <span>UPDATE:</span>
              <MarkdownRenderer>
                {notification.content}
              </MarkdownRenderer>
            </UpdateText>
          </Grid>
        </Grid>
      </StyledDialogContent>
    </Fragment>
  )
}

export default PaidLeaveNotificationContentModal
